import { render } from "./djylResourceNew.vue?vue&type=template&id=76852b0a&scoped=true"
import script from "./djylResourceNew.vue?vue&type=script&lang=js"
export * from "./djylResourceNew.vue?vue&type=script&lang=js"

import "./djylResourceNew.vue?vue&type=style&index=0&id=76852b0a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76852b0a"]])

export default __exports__